/**
 *
 * Asynchronously loads the component for CasesAndInvoiceTracker
 *
 */

import loadable from "../../utils/loadable";

export default loadable(() => import("./index"));
